import Inspector from './inspector';

// Remover caso não seja utilizado
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { variant, margin, sideImage, plansName } = attributes;

  const ALLOWED_BLOCKS = ['core/heading', 'app/topics', 'base/button-sumicity', 'core/image'];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section
        className={`PlansDetailsGridPlans Container ${variant} ${margin} wp-editor`}
      >
        <div className="plansContainer">
          <div className="contentContainer">
            <InnerBlocks
              allowedBlocks={ALLOWED_BLOCKS}
              template={[
                [
                  'core/image',
                ],
                [
                  'core/heading',
                  {
                    level: 2,
                    content: 'Título',
                  },
                ],
                [
                  'app/topics',
                  {
                    hasIcon: true,
                  }
                ],
                [
                  'app/topics',
                  {
                    hasIcon: true,
                  }
                ],
                [
                  'app/topics',
                  {
                    hasIcon: true,
                  }
                ],
                [
                  'base/button-sumicity',
                  {
                    content: 'Nome do botão',
                    variant: 'btn-orange',
                    align: 'left'
                  }
                ]
              ]}
            />
          </div>
          <div className="imageContainer">
            <img src={sideImage.src} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
